import { defineMessages } from "@formatjs/intl"
import type { RemoveVehicleReason } from "./RemoveVehicleReason"

export const removeVehicleReasonMessages = defineMessages<RemoveVehicleReason>({
	COMMISSION_CAR_RETURNED: {
		defaultMessage: "Return commission vehicle to customer",
		id: "removal.reason.commission.car.returned",
	},
	DEALERSHIP_DELETED: {
		defaultMessage: "Dealership Deleted",
		id: "removal.reason.dealershipDeleted",
	},
	DELIVERED_TO_CUSTOMER: {
		defaultMessage: "Delivered to Customer",
		id: "removal.reason.deliveredToCustomer",
	},
	DRAFT_EXPIRED: {
		defaultMessage: "Draft Expired",
		id: "removal.reason.draftExpired",
	},
	INVALID_VEHICLE_TYPE: {
		defaultMessage: "Invalid Vehicle Type",
		id: "removal.reason.invalidVehicleType",
	},
	NOT_AVAILABLE_FOR_MARKETING: {
		defaultMessage: "Not Available for Marketing",
		id: "removal.reason.notAvailableForMarketing",
	},
	OTHER: {
		defaultMessage: "Other",
		id: "removal.reason.others",
	},
	PREPRODUCTION_VEHICLE_SOLD: {
		defaultMessage: "Preproduction Vehicle Sold",
		id: "removal.reason.preproductionVehicleSold",
	},
	STOLEN: {
		defaultMessage: "Stolen",
		id: "removal.reason.stolen",
	},
	TRADED_TO_OTHER_DEALER: {
		defaultMessage: "Traded to Other Dealer",
		id: "removal.reason.tradedToOtherDealer",
	},
	TRANSFERRED_TO_INTERNAL_ORGANISATION: {
		defaultMessage: "Transferred to Internal Organisation",
		id: "removal.reason.transferredToInternalOrganisation",
	},
	TRANSFERRED_TO_NON_PVMS_MARKET: {
		defaultMessage: "Transferred to Non-PVMS Market",
		id: "removal.reason.transferredToNonPvmsMarket",
	},
	TRANSFERRED_TO_OTHER_DEALER_WITHIN_DEALER_GROUP: {
		defaultMessage: "Vehicle transfer within dealer group",
		id: "removal.reason.transferredToOtherDealerWithinDealerGroup",
	},
	UPLOADED_BY_MISTAKE: {
		defaultMessage: "Uploaded by mistake",
		id: "removal.reason.upload.by.mistake",
	},
})
